import { useEffect, useState } from "react";
import api from "../api/api";

function Subscriptions() {
  const [subs,    setSubs]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/user/subscriptions")
      .then(res => setSubs(Array.isArray(res.data) ? res.data : []))
      .catch(() => setSubs([]))
      .finally(() => setLoading(false));
  }, []);

  const pause = async (id) => {
    try {
      await api.put(`/user/pause/${id}`);
      setSubs(prev => prev.map(s =>
        s.subscriptionId === id ? { ...s, status: "PAUSED" } : s
      ));
    } catch { alert("Failed to pause subscription"); }
  };

  const resume = async (id) => {
    try {
      await api.put(`/user/resume/${id}`);
      setSubs(prev => prev.map(s =>
        s.subscriptionId === id ? { ...s, status: "ACTIVE" } : s
      ));
    } catch { alert("Failed to resume subscription"); }
  };

  if (loading) return <p className="text-muted fs-13">Loading subscriptions…</p>;

  if (subs.length === 0) return (
    <div className="empty-state">
      <div className="empty-icon">⭐</div>
      <div className="empty-title">No subscriptions yet</div>
      <div className="empty-sub">Browse newspapers to subscribe</div>
    </div>
  );

  return (
    <div>
      <div className="section-hdr mb-24">
        <div className="section-hdr-title">My Subscriptions</div>
        <span className="badge badge-muted">{subs.length} active</span>
      </div>

      {subs.map(s => (
        <div className="sub-row" key={s.subscriptionId}>
          <div className="sub-row-info">
            <div className="sub-row-name">📰 {s.newspaperName}</div>
            <div className="sub-row-meta">
              {s.billingType} billing · Since {s.startDate}
            </div>
          </div>

          <span className={`badge ${
            s.status === "ACTIVE"  ? "badge-success" :
            s.status === "PAUSED"  ? "badge-warning"  :
                                     "badge-danger"
          }`}>
            {s.status}
          </span>

          <div className="sub-row-actions">
            {s.status === "ACTIVE" && (
              <button className="btn btn-outline btn-sm" onClick={() => pause(s.subscriptionId)}>
                ⏸ Pause
              </button>
            )}
            {s.status === "PAUSED" && (
              <button className="btn btn-success btn-sm" onClick={() => resume(s.subscriptionId)}>
                ▶ Resume
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Subscriptions;
